import Api from './Api';

const Orders = () => {
  return Api().get('/orders');
};

const Order = (id) => {
  return Api().get(`/orders/${id}`);
};

const AddOrder = (data) => {
  return Api().post('/orders', data);
};

const EditOrder = (id, data) => {
  return Api().put(`/orders/${id}`, data);
};

const OrderPaid = (id, data) => {
  return Api().put(`/orders/paid/${id}`, data);
};

const CancelOrder = (id, data) => {
  return Api().put(`/orders/cancel/${id}`, data);
};

export { Orders, Order, AddOrder, EditOrder, CancelOrder, OrderPaid };
